/**
 * Denis Callinan
 * Project Andromeda
 * July 31st, 2020
 * Header.js - Header section
 */

import React from 'react';

// Components
import InfoBox from '../components/InfoBox/InfoBox.js'

// Media
import Splash from '../img/background.jpg'
import Down from '../img/down.png'

export default class Header extends React.Component {

    handleClick() {
        const element = document.getElementById("page-A");
        const y = element.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    render() {
        return(
            <header className = "App-header">
                <InfoBox />
                <img id = "splash" src = {Splash} alt = "UVa" />
                <input type="image" id = "down-arrow" src = {Down} alt = "Content below" onClick = {this.handleClick.bind(this)}/>
            </header>
        );
    }
}